import { VehicleInstanceMarkets, VehicleLifeCycleStatuses } from "../../../classes/Api/Vehicle";
const global = window;
const isNotSold = (instance) => {
    return instance.life_cycle_status !== VehicleLifeCycleStatuses.SOLD;
};
const standInValue = (instance) => {
    return showVatExclusiveCosts(instance) ?
        instance.net_stand_in_value : instance.stand_in_value;
};
const showVatExclusiveCosts = (instance) => {
    return global.marque.ui.tweaks.vat_exclusive_financials;
};
const showGrossMargin = () => {
    return global.marque.ui.tweaks.show_gross_margin;
};
const isAlien = (instance) => {
    return instance.market === VehicleInstanceMarkets.NONE && !instance.owner;
};
const isPreliminaryPartExchange = (instance) => {
    return !instance.purchase_cost && instance.is_part_exchange;
};
const purchaseCost = (instance) => {
    if (isPreliminaryPartExchange(instance)) {
        return instance.part_exchange_record.our_offer;
    }
    return instance.purchase_cost ? instance.purchase_cost.total_gross : 0;
};
const soldVsRetailMargin = (instance) => {
    if (instance.sold_for && (instance.retail_price ?? 0) > 0) {
        return instance.sold_for / ((instance.retail_price ?? 0) / 100);
    }
    return '';
};
const marginStyles = (instance) => {
    let styles = 'font-weight: 500;';
    if (instance.margin >= global.marque.ui.targetMargin) {
        styles += 'color: green;';
    }
    else {
        styles += 'color: red;';
    }
    return styles;
};
const marginPercentage = (instance, type) => {
    let sellingPrice = instance.retail_price ?? 0;
    if (instance.sold_for > 0) {
        sellingPrice = instance.sold_for;
    }
    let margin = instance.net_margin;
    if (type === 'gross') {
        margin = instance.margin;
    }
    return sellingPrice > 0 ? ((margin / sellingPrice) * 100).toFixed(1) : 0;
};
const isFunded = (instance) => {
    return !!instance.funding_record;
};
export { isFunded, isNotSold, standInValue, showVatExclusiveCosts, isAlien, isPreliminaryPartExchange, purchaseCost, soldVsRetailMargin, marginStyles, marginPercentage, showGrossMargin, };
